var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa",class:{'fa-shopping-cart': this.isValid, 'fa-exclamation-triangle': !this.isValid}})])}
var staticRenderFns = []

export { render, staticRenderFns }